import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function AttachMoney(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M11 17v-1H9a3 3 0 010-6h2V8h2v2h2v2h-2v4h-2zM12 2a10 10 0 100 20 10 10 0 000-20z" />
    </SvgIcon>
  )
}
